<template>
  <content-modal
    class="message-modal change-teacher-account-option-modal"
    :visible="visible"
    :auto-hide-off="autoHideOff"
    :close-aria-label="closeAriaLabel"
    :size="size"
    @modal-shown="actionShown"
    @modal-hidden="actionHidden"
    @modal-hide-request="actionHideRequest"
  >
    <template #title>{{ t("change_to_teacher_modal_title_label") }}</template>
    <template #content>
      <modal-content>
        <template #content>
          <cv-button-set>
            <cv-button kind="primary" size="field" @click="actionPrimary">
              {{ t("button_continue_with_edupass_label") }}
            </cv-button>
            <cv-link href="#" class="sls-login-link" @click.prevent="enableSlsLogin">
              {{ t("button_continue_with_sls_label") }}
            </cv-link>
          </cv-button-set>
        </template>
      </modal-content>
    </template>
  </content-modal>
</template>

<script setup lang="ts">
import modalEventBus from "@plugins/modal/service/event-bus";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";
import { useVm } from "@utils/vm.ts";

const { vmNode } = useVm();

interface Props {
  params?: object | null;
}

const props = withDefaults(defineProps<Props>(), {
  params: null,
});

const { t } = useI18n();

const password = ref("");
const closeAriaLabel = ref("Close");
const size = ref("small");
const visible = ref(true);
const autoHideOff = ref(true);

const actionShown = () => {
  visible.value = true;
};

const actionHidden = () => {
  props.params?.actionPrimary({ validated: false, password: password.value });
  visible.value = false;
  modalEventBus.$emit("modal-hidden", vmNode.key);
};

const actionPrimary = () => {
  props.params?.actionPrimary({ validated: true });
  visible.value = false;
};

const actionHideRequest = (event: CustomEvent) => {
  // to prevent close modal upon clicking anywhere outside the modal container
  if (event["cv:reason"] !== "external-click") {
    actionHidden();
  }
};

const enableSlsLogin = () => {
  props.params?.actionSecondary();
  visible.value = false;
};

onMounted(() => {
  visible.value = true;
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.change-teacher-account-option-modal {
  .content {
    .bx--btn-set {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin: $spacing-07 0;

      .bx--btn {
        width: 260px;
        max-width: 260px;
      }

      .sls-login-link {
        @include carbon--type-style("label-01", true);
        margin-top: $spacing-05;
      }
    }
  }
}
</style>
